export const PolicyData = [
  {
    body: `Our cab booking app provides a convenient and reliable way to book rides and travel comfortably to your destination. With a user-friendly interface and a wide range of features, we aim to enhance your transportation experience. Here's what you can expect from our cab booking app:`,

    content: [
      {
        title: " Easy Registration:",

        description: ` Download the app and sign up with your email address or phone number.

      Provide the necessary details, such as your name and preferred payment method, to create your account.`,
      },

      {
        title: " Quick Booking Process:",

        description: ` Add your pickup location and destination to request a ride.

      Choose from various vehicle options based on your needs, such as economy cars, sedans, or SUVs.

      View estimated fares and arrival times before confirming your booking.`,
      },

      {
        title: " Real-Time Tracking:",

        description: ` Track your assigned driver's location and estimated time of arrival in real-time on the map within the app.

      Get updates on any changes to the pickup or drop-off locations.`,
      },

      {
        title: " Safe and Professional Drivers:",

        description: `Our drivers undergo thorough background checks and are selected for their professionalism and driving skills.

      They are committed to providing you with a safe and comfortable journey.`,
      },

      {
        title: " Transparent Pricing:",

        description: ` Fare estimates are provided upfront, taking into account factors such as distance, time, and any additional charges like tolls or surcharges.

      You'll have a clear understanding of the cost before confirming your booking.`,
      },

      {
        title: "Multiple Payment Options:",

        description: ` Choose from various payment methods, including credit cards, debit cards, and digital wallets, for a seamless and secure payment experience.

      Payment details can be saved securely for quick and hassle-free transactions.`,
      },

      {
        title: " Reliable Customer Support:",

        description: `Our dedicated customer support team is available to assist you with any inquiries, concerns, or issues you may have.

      Contact us through the app, website, or other specified communication channels.`,
      },

      {
        title: " Ride History and Receipts:",

        description: ` Access your ride history within the app to view past trips, including details like pickup/drop-off locations, fare breakdowns, and driver information.

      Receipts for completed rides can be easily downloaded or emailed for your records.`,
      },

      {
        title: "Ratings and Reviews:",

        description: `Rate and provide feedback on your ride experience, helping us maintain high-quality service standards.

      We value your feedback and continuously strive to improve our services based on your input.`,
      },

      {
        title: "Special Features and Promotions:",

        description: ` Stay updated with our app for special features, promotions, and discounts that enhance your ride experience and provide cost-saving opportunities.

      Experience the convenience and reliability of our cab booking app for all your transportation needs. Download [Your App Name] today and enjoy a seamless travel experience!`,
      },
    ],
  },
];
export const PolicyData_hindi = [
  {
    body: `हमारा कैब बुकिंग ऐप सवारी बुक करने और आपके गंतव्य तक आराम से यात्रा करने का एक सुविधाजनक और विश्वसनीय तरीका प्रदान करता है। उपयोगकर्ता के अनुकूल इंटरफेस और सुविधाओं की एक विस्तृत श्रृंखला के साथ, हमारा लक्ष्य आपके परिवहन अनुभव को बढ़ाना है। यहां बताया गया है कि आप हमारे कैब बुकिंग ऐप से क्या उम्मीद कर सकते हैं:
    `,
    content: [
      {
        title: `आसान पंजीकरण:`,
        description: `ऐप डाउनलोड करें और अपने ईमेल पते या फोन नंबर से साइन अप करें। अपना खाता बनाने के लिए आवश्यक विवरण, जैसे अपना नाम और पसंदीदा भुगतान विधि प्रदान करें।`,
      },
      {
        title: `त्वरित बुकिंग प्रक्रिया:`,
        description: `सवारी का अनुरोध करने के लिए अपना पिकअप स्थान और गंतव्य जोड़ें। अपनी आवश्यकताओं के आधार पर विभिन्न वाहन विकल्पों में से चुनें, जैसे इकोनॉमी कार, सेडान या एसयूवी। अपनी बुकिंग की पुष्टि करने से पहले अनुमानित किराया और आगमन समय देखें।
        `,
      },
      {
        title: ` वास्तविक समय ट्रैकिंग:`,
        description: `ऐप के भीतर मानचित्र पर वास्तविक समय में अपने निर्दिष्ट ड्राइवर के स्थान और आगमन के अनुमानित समय को ट्रैक करें। पिकअप या ड्रॉप-ऑफ स्थानों में किसी भी बदलाव पर अपडेट प्राप्त करें।`,
      },
      {
        title: `आसान पंजीकरण:`,
        description: `ऐप डाउनलोड करें और अपने ईमेल पते या फोन नंबर से साइन अप करें। अपना खाता बनाने के लिए आवश्यक विवरण, जैसे अपना नाम और पसंदीदा भुगतान विधि प्रदान करें।`,
      },
      {
        title: `त्वरित बुकिंग प्रक्रिया:`,
        description: `सवारी का अनुरोध करने के लिए अपना पिकअप स्थान और गंतव्य जोड़ें। अपनी आवश्यकताओं के आधार पर विभिन्न वाहन विकल्पों में से चुनें, जैसे इकोनॉमी कार, सेडान या एसयूवी। अपनी बुकिंग की पुष्टि करने से पहले अनुमानित किराया और आगमन समय देखें।
         `,
      },
      {
        title: ` वास्तविक समय ट्रैकिंग:`,
        description: `ऐप के भीतर मानचित्र पर वास्तविक समय में अपने निर्दिष्ट ड्राइवर के स्थान और आगमन के अनुमानित समय को ट्रैक करें। पिकअप या ड्रॉप-ऑफ स्थानों में किसी भी बदलाव पर अपडेट प्राप्त करें।`,
      },
    ],
  },
];
export const PolicyData_kannada = [
  {
    body: `ನಮ್ಮ ಕ್ಯಾಬ್ ಬುಕಿಂಗ್ ಅಪ್ಲಿಕೇಶನ್ ರೈಡ್‌ಗಳನ್ನು ಬುಕ್ ಮಾಡಲು ಮತ್ತು ನಿಮ್ಮ ಗಮ್ಯಸ್ಥಾನಕ್ಕೆ ಆರಾಮವಾಗಿ ಪ್ರಯಾಣಿಸಲು ಅನುಕೂಲಕರ ಮತ್ತು ವಿಶ್ವಾಸಾರ್ಹ ಮಾರ್ಗವನ್ನು ಒದಗಿಸುತ್ತದೆ. ಬಳಕೆದಾರ ಸ್ನೇಹಿ ಇಂಟರ್ಫೇಸ್ ಮತ್ತು ವ್ಯಾಪಕ ಶ್ರೇಣಿಯ ವೈಶಿಷ್ಟ್ಯಗಳೊಂದಿಗೆ, ನಿಮ್ಮ ಸಾರಿಗೆ ಅನುಭವವನ್ನು ಹೆಚ್ಚಿಸುವ ಗುರಿಯನ್ನು ನಾವು ಹೊಂದಿದ್ದೇವೆ. ನಮ್ಮ ಕ್ಯಾಬ್ ಬುಕಿಂಗ್ ಅಪ್ಲಿಕೇಶನ್‌ನಿಂದ ನೀವು ಏನನ್ನು ನಿರೀಕ್ಷಿಸಬಹುದು ಎಂಬುದು ಇಲ್ಲಿದೆ:
      `,
    content: [
      {
        title: `ಸುಲಭ ನೋಂದಣಿ:`,
        description: `ಅಪ್ಲಿಕೇಶನ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ ಮತ್ತು ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸ ಅಥವಾ ಫೋನ್ ಸಂಖ್ಯೆಯೊಂದಿಗೆ ಸೈನ್ ಅಪ್ ಮಾಡಿ. ನಿಮ್ಮ ಖಾತೆಯನ್ನು ರಚಿಸಲು ನಿಮ್ಮ ಹೆಸರು ಮತ್ತು ಆದ್ಯತೆಯ ಪಾವತಿ ವಿಧಾನದಂತಹ ಅಗತ್ಯ ವಿವರಗಳನ್ನು ಒದಗಿಸಿ.
         `,
      },
      {
        title: `ತ್ವರಿತ ಬುಕಿಂಗ್ ಪ್ರಕ್ರಿಯೆ:`,
        description: `ಸವಾರಿಗಾಗಿ ವಿನಂತಿಸಲು ನಿಮ್ಮ ಪಿಕಪ್ ಸ್ಥಳ ಮತ್ತು ಗಮ್ಯಸ್ಥಾನವನ್ನು ಸೇರಿಸಿ. ಎಕಾನಮಿ ಕಾರ್‌ಗಳು, ಸೆಡಾನ್‌ಗಳು ಅಥವಾ SUVಗಳಂತಹ ನಿಮ್ಮ ಅಗತ್ಯಗಳನ್ನು ಆಧರಿಸಿ ವಿವಿಧ ವಾಹನ ಆಯ್ಕೆಗಳಿಂದ ಆರಿಸಿಕೊಳ್ಳಿ. ನಿಮ್ಮ ಬುಕಿಂಗ್ ಅನ್ನು ದೃಢೀಕರಿಸುವ ಮೊದಲು ಅಂದಾಜು ದರಗಳು ಮತ್ತು ಆಗಮನದ ಸಮಯವನ್ನು ವೀಕ್ಷಿಸಿ.
          `,
      },
      {
        title: `ನೈಜ-ಸಮಯದ ಟ್ರ್ಯಾಕಿಂಗ್:`,
        description: `ಅಪ್ಲಿಕೇಶನ್‌ನಲ್ಲಿನ ನಕ್ಷೆಯಲ್ಲಿ ನೈಜ ಸಮಯದಲ್ಲಿ ನಿಮ್ಮ ನಿಯೋಜಿಸಲಾದ ಚಾಲಕನ ಸ್ಥಳ ಮತ್ತು ಆಗಮನದ ಅಂದಾಜು ಸಮಯವನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ. ಪಿಕಪ್ ಅಥವಾ ಡ್ರಾಪ್-ಆಫ್ ಸ್ಥಳಗಳಿಗೆ ಯಾವುದೇ ಬದಲಾವಣೆಗಳ ಕುರಿತು ನವೀಕರಣಗಳನ್ನು ಪಡೆಯಿರಿ.
          `,
      },
      {
        title: `ಸುರಕ್ಷಿತ ಮತ್ತು ವೃತ್ತಿಪರ ಚಾಲಕರು:`,
        description: `ನಮ್ಮ ಚಾಲಕರು ಸಂಪೂರ್ಣ ಹಿನ್ನೆಲೆ ತಪಾಸಣೆಗೆ ಒಳಗಾಗುತ್ತಾರೆ ಮತ್ತು ಅವರ ವೃತ್ತಿಪರತೆ ಮತ್ತು ಚಾಲನಾ ಕೌಶಲ್ಯಕ್ಕಾಗಿ ಆಯ್ಕೆಮಾಡಲಾಗುತ್ತದೆ. ಅವರು ನಿಮಗೆ ಸುರಕ್ಷಿತ ಮತ್ತು ಆರಾಮದಾಯಕ ಪ್ರಯಾಣವನ್ನು ಒದಗಿಸಲು ಬದ್ಧರಾಗಿದ್ದಾರೆ.
          `,
      },
      {
        title: `ಸುಲಭ ನೋಂದಣಿ:`,
        description: `ಅಪ್ಲಿಕೇಶನ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ ಮತ್ತು ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸ ಅಥವಾ ಫೋನ್ ಸಂಖ್ಯೆಯೊಂದಿಗೆ ಸೈನ್ ಅಪ್ ಮಾಡಿ. ನಿಮ್ಮ ಖಾತೆಯನ್ನು ರಚಿಸಲು ನಿಮ್ಮ ಹೆಸರು ಮತ್ತು ಆದ್ಯತೆಯ ಪಾವತಿ ವಿಧಾನದಂತಹ ಅಗತ್ಯ ವಿವರಗಳನ್ನು ಒದಗಿಸಿ.
          `,
      },
      {
        title: `ತ್ವರಿತ ಬುಕಿಂಗ್ ಪ್ರಕ್ರಿಯೆ:`,
        description: `ಸವಾರಿಗಾಗಿ ವಿನಂತಿಸಲು ನಿಮ್ಮ ಪಿಕಪ್ ಸ್ಥಳ ಮತ್ತು ಗಮ್ಯಸ್ಥಾನವನ್ನು ಸೇರಿಸಿ. ಎಕಾನಮಿ ಕಾರ್‌ಗಳು, ಸೆಡಾನ್‌ಗಳು ಅಥವಾ SUVಗಳಂತಹ ನಿಮ್ಮ ಅಗತ್ಯಗಳನ್ನು ಆಧರಿಸಿ ವಿವಿಧ ವಾಹನ ಆಯ್ಕೆಗಳಿಂದ ಆರಿಸಿಕೊಳ್ಳಿ. ನಿಮ್ಮ ಬುಕಿಂಗ್ ಅನ್ನು ದೃಢೀಕರಿಸುವ ಮೊದಲು ಅಂದಾಜು ದರಗಳು ಮತ್ತು ಆಗಮನದ ಸಮಯವನ್ನು ವೀಕ್ಷಿಸಿ.
           `,
      },
      {
        title: `ನೈಜ-ಸಮಯದ ಟ್ರ್ಯಾಕಿಂಗ್:`,
        description: `ಅಪ್ಲಿಕೇಶನ್‌ನಲ್ಲಿನ ನಕ್ಷೆಯಲ್ಲಿ ನೈಜ ಸಮಯದಲ್ಲಿ ನಿಮ್ಮ ನಿಯೋಜಿಸಲಾದ ಚಾಲಕನ ಸ್ಥಳ ಮತ್ತು ಆಗಮನದ ಅಂದಾಜು ಸಮಯವನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ. ಪಿಕಪ್ ಅಥವಾ ಡ್ರಾಪ್-ಆಫ್ ಸ್ಥಳಗಳಿಗೆ ಯಾವುದೇ ಬದಲಾವಣೆಗಳ ಕುರಿತು ನವೀಕರಣಗಳನ್ನು ಪಡೆಯಿರಿ.
           `,
      },
      {
        title: `ಸುರಕ್ಷಿತ ಮತ್ತು ವೃತ್ತಿಪರ ಚಾಲಕರು:`,
        description: `ನಮ್ಮ ಚಾಲಕರು ಸಂಪೂರ್ಣ ಹಿನ್ನೆಲೆ ತಪಾಸಣೆಗೆ ಒಳಗಾಗುತ್ತಾರೆ ಮತ್ತು ಅವರ ವೃತ್ತಿಪರತೆ ಮತ್ತು ಚಾಲನಾ ಕೌಶಲ್ಯಕ್ಕಾಗಿ ಆಯ್ಕೆಮಾಡಲಾಗುತ್ತದೆ. ಅವರು ನಿಮಗೆ ಸುರಕ್ಷಿತ ಮತ್ತು ಆರಾಮದಾಯಕ ಪ್ರಯಾಣವನ್ನು ಒದಗಿಸಲು ಬದ್ಧರಾಗಿದ್ದಾರೆ.
           `,
      },
    ],
  },
];
